import React from "react";

const ListIcon = (props) => (
<svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
    <line x1={8} y1={6} x2={21} y2={6} stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    <line x1={8} y1={12} x2={21} y2={12} stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    <line x1={8} y1={18} x2={21} y2={18} stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    <line x1={3} y1={6} x2={3.01} y2={6} stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    <line x1={3} y1={12} x2={3.01} y2={12} stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    <line x1={3} y1={18} x2={3.01} y2={18} stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default ListIcon;
